module.exports = __webpack_public_path__ + "img/1m.6e4bbfb0.jpg";